import React, { useState } from "react";
import './styles.css'
import { message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { MAIN_URL } from "../../config/utils";
import { FaArrowLeftLong } from "react-icons/fa6";
import Arbitrator_new_logo_eng from '../../assets/images/new-logo-white.svg';
import Arbitrator_new_logo_ru from '../../assets/images/new-logo-ru-white.svg';
import Arbitrator_new_logo_uz from '../../assets/images/new-logo-uz-white.svg';


type FieldType = {
    firstName?: string;
    lastName?: string;
    email?: string;
    password?: string;
    phoneNumber?: string;
    remember?: string;
};

const RegisterPage: React.FC = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [firstName, setfirstName] = useState('');
    const [lastName, setlastName] = useState('');
    const active_lang = localStorage.getItem('i18lang')

    const handleAuth = async () => {
        try {
          const response = await axios.post(`${MAIN_URL}/people`, { firstName, lastName, 'user': {email: email, password: password,}}, {
            headers: {
              'Content-Type': 'application/json',
            },
          });
    
          if (response.status === 200) {
            // dispatch(login(response.data));
            navigate('/my-information')
            localStorage?.setItem('access_token', response?.data?.accessToken)
            message.success(`${t('You are successfully logged in!')}`);
          } else {
            navigate('/login')
            message.error(`${t('Login error!')}`);
          }
        } catch (error) {
          navigate('/login')
          message.error(`${t('An error occurred while logging in. Please try again later')}`);
        }
      };

    return (
        <div className="register_page bg-main_color min-h-screen text-white w-full lg:px-20 sm:px-10 px-5">
            <div className="max-w-[1681px] w-full mx-auto">
                <div className="pt-[30px]">
                    <Link to={'/'} className='lg:block hidden'>
                        <img src={active_lang == 'uz' ? Arbitrator_new_logo_uz : active_lang == 'ru' ? Arbitrator_new_logo_ru : Arbitrator_new_logo_eng} alt="Logo white" className="w-[210px] h-[170px]" />
                    </Link>
                    <div className='sm:flex lg:hidden  hidden justify-between items-center py-5 sm:px-10 px-5'>
                        <Link to={"/"}>
                            <img src={active_lang == 'uz' ? Arbitrator_new_logo_uz : active_lang == 'ru' ? Arbitrator_new_logo_ru : Arbitrator_new_logo_eng} alt="logo" className="w-[210px] h-[180px]" />
                        </Link>
                        <div className=' rounded-3xl w-[69px] h-[62px] flex items-center justify-center bg-[#D9D9D94D]'>
                            <FaArrowLeftLong size={30} color='white' onClick={() => navigate(-1)} />
                        </div>
                    </div> 
                    <div className="w-[500px] max-sm:w-full px-3 lg:mr-auto max-lg:mx-auto lg:mt-[10%] sm:mt-[calc(100vh-750px)] mt-[5%]">
                        <h2 className="text-[40px] font-bold">{t('Welcome!')}</h2>
                        <p className="font-semibold text-lg mb-8">{t('Registration')}</p>
                        {/* <Form
                            name="basic"
                            initialValues={{ remember: true }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete="off"
                        >
                            <Form.Item<FieldType> name="firstName" rules={[{ required: true, message: 'Please input your first name!' }]} >
                                <Input className="h-[40px]" placeholder={`${t('Enter first name ...')}`} />
                            </Form.Item>

                            <Form.Item<FieldType> name="lastName" rules={[{ required: true, message: 'Please input your last name!' }]} >
                                <Input className="h-[40px]" placeholder={`${t('Enter last name ...')}`} />
                            </Form.Item>

                            <Form.Item<FieldType> name="email" rules={[{ required: true, message: `${t('Please input your email!')}` }]} >
                                <Input className="h-[40px]" placeholder={`${t("Enter email ...")}`} />
                            </Form.Item>

                            <Form.Item<FieldType> name="password" rules={[{ required: true, message: `${t('Please input your password!')}` }]} >
                                <Input.Password className="h-[40px]" placeholder={`${t("Enter password ...")}`} />
                            </Form.Item>

                            <Form.Item<FieldType> name="phoneNumber" rules={[{ required: false, message: `${t('Please input your phone number!')}` }]} >
                                <PhoneNumberInput />
                            </Form.Item>

                            <Form.Item<FieldType> name="remember" valuePropName="checked">
                                <Checkbox className="text-white">{t('Remember me')}</Checkbox>
                            </Form.Item>

                            <Form.Item>
                                <Button htmlType="submit" className="w-full bg-main_color border h-[40px] text-[20px] py-0 border-solid border-white text-white font-bold rounded">
                                    {t('Registration')}
                                </Button>
                            </Form.Item>
                        </Form> */}

                        <div className='w-full'>
                            <input required type="text" value={firstName} onChange={(e) => setfirstName(e.target.value)} placeholder="First name" className='w-full mb-4 rounded-md h-[40px] py-2 px-3 focus:border-none outline-none text-[#29487E]' />
                            <input required type="text" value={lastName} onChange={(e) => setlastName(e.target.value)} placeholder="Last name" className='w-full mb-4 rounded-md h-[40px] py-2 px-3 focus:border-none outline-none text-[#29487E]' />
                            <input required type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className='w-full mb-4 rounded-md h-[40px] py-2 px-3 focus:border-none outline-none text-[#29487E]' />
                            <input required type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className='w-full mb-4 rounded-md h-[40px] py-2 px-3 focus:border-none outline-none text-[#29487E]' />
                            <button onClick={handleAuth} className="w-full bg-main_color border h-[40px] text-[20px] py-0 border-solid border-white text-white font-bold rounded mb-4">{t('Registration')}</button>
                        </div>
                        <span>{t('You have an account?')} <Link to={'/login'} className="font-bold">{t('Login')}</Link></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RegisterPage